// src/components/RankingMotoristas.js
import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api';
import { FaTimes, FaTrophy, FaMedal, FaCrown, FaSpinner, FaGlobeAmericas, FaCalendarAlt, FaCheckDouble } from 'react-icons/fa';
import './RankingMotoristas.css';

const formatCurrency = (val) => parseFloat(val || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

export default function RankingMotoristas({ onClose }) {
    const today = new Date();
    const [mes, setMes] = useState(today.getMonth() + 1);
    const [ano, setAno] = useState(today.getFullYear());
    const [isGeral, setIsGeral] = useState(false); // NOVO: Estado para Visão Geral
    const [rankedDrivers, setRankedDrivers] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchRanking = useCallback(async () => {
        setLoading(true);
        try {
            // Se isGeral for true, mandamos o parâmetro geral=true
            const url = isGeral 
                ? `/api/drivers/ranking/mensal?geral=true`
                : `/api/drivers/ranking/mensal?mes=${mes}&ano=${ano}`;
            
            const response = await api.get(url);
            setRankedDrivers(response.data);
        } catch (err) {
            console.error("Erro ao buscar ranking:", err);
        } finally {
            setLoading(false);
        }
    }, [mes, ano, isGeral]);

    useEffect(() => {
        fetchRanking();
    }, [fetchRanking]);

    const podium = rankedDrivers.slice(0, 3);
    const others = rankedDrivers.slice(3);

    const meses = [
        "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
        "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
    ];

    return (
        <div className="rnk-overlay" onClick={onClose}>
            <div className="rnk-modal" onClick={e => e.stopPropagation()}>
                <header className="rnk-header">
                    <div className="rnk-title-group">
                        <FaTrophy className="rnk-trophy-main" />
                        <div>
                            <h2>{isGeral ? 'Elite Histórica' : 'Elite do Mês'}</h2>
                            <div className="rnk-controls-row">
                                <button 
                                    className={`rnk-view-toggle ${isGeral ? 'active' : ''}`}
                                    onClick={() => setIsGeral(!isGeral)}
                                >
                                    {isGeral ? <><FaCalendarAlt/> Mudar para Mensal</> : <><FaGlobeAmericas/> Visão Geral</>}
                                </button>

                                {!isGeral && (
                                    <div className="rnk-selectors animate-fade-in">
                                        <select value={mes} onChange={(e) => setMes(e.target.value)}>
                                            {meses.map((m, i) => <option key={m} value={i + 1}>{m}</option>)}
                                        </select>
                                        <select value={ano} onChange={(e) => setAno(e.target.value)}>
                                            {[2024, 2025, 2026].map(y => <option key={y} value={y}>{y}</option>)}
                                        </select>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <button className="rnk-close-btn" onClick={onClose}><FaTimes /></button>
                </header>

                <div className="rnk-body">
                    {loading ? (
                        <div className="rnk-loading-state"><FaSpinner className="rnk-spin" /><p>Consolidando dados...</p></div>
                    ) : (
                        <>
                            <div className="rnk-podium">
                                {podium[1] && (
                                    <div className="rnk-podium-box second">
                                        <div className="rnk-user-circle">
                                            <div className="rnk-img-stub">{podium[1].nome.charAt(0)}</div>
                                            <FaMedal className="rnk-med silver" />
                                        </div>
                                        <span className="rnk-podium-name">{podium[1].nome.split(' ')[0]}</span>
                                        <div className="rnk-bar silver">
                                            <strong>2º</strong>
                                            <small>{formatCurrency(podium[1].faturamento)}</small>
                                            <span className="rnk-os-count"><FaCheckDouble /> {podium[1].total_os} OS</span>
                                        </div>
                                    </div>
                                )}

                                {podium[0] && (
                                    <div className="rnk-podium-box first">
                                        <FaCrown className="rnk-crown-top" />
                                        <div className="rnk-user-circle gold-wrap">
                                            <div className="rnk-img-stub">{podium[0].nome.charAt(0)}</div>
                                            <FaMedal className="rnk-med gold" />
                                        </div>
                                        <span className="rnk-podium-name">{podium[0].nome.split(' ')[0]}</span>
                                        <div className="rnk-bar gold">
                                            <strong>1º</strong>
                                            <small>{formatCurrency(podium[0].faturamento)}</small>
                                            <span className="rnk-os-count"><FaCheckDouble /> {podium[0].total_os} OS</span>
                                        </div>
                                    </div>
                                )}

                                {podium[2] && (
                                    <div className="rnk-podium-box third">
                                        <div className="rnk-user-circle">
                                            <div className="rnk-img-stub">{podium[2].nome.charAt(0)}</div>
                                            <FaMedal className="rnk-med bronze" />
                                        </div>
                                        <span className="rnk-podium-name">{podium[2].nome.split(' ')[0]}</span>
                                        <div className="rnk-bar bronze">
                                            <strong>3º</strong>
                                            <small>{formatCurrency(podium[2].faturamento)}</small>
                                            <span className="rnk-os-count"><FaCheckDouble /> {podium[2].total_os} OS</span>
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div className="rnk-others-list">
                                {others.length > 0 ? others.map((m, i) => (
                                    <div key={m.id} className="rnk-list-row">
                                        <span className="rnk-row-pos">{i + 4}º</span>
                                        <div className="rnk-row-info">
                                            <strong>{m.nome}</strong>
                                            <span>{m.total_os} ordens concluídas</span>
                                        </div>
                                        <div className="rnk-row-val">
                                            <strong>{formatCurrency(m.faturamento)}</strong>
                                        </div>
                                    </div>
                                )) : rankedDrivers.length === 0 && <div className="rnk-empty">Sem atividades no período.</div>}
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}